// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection_hero__yIlYY","container":"HeroSection_container__d2XT-","content":"HeroSection_content__fk-ek","link":"HeroSection_link__FI7F1"};